import RoleDTO from "../api/dtos/Role";

export const hasAccess = (userRole: RoleDTO | undefined | null): boolean => {
    return userRole ? (userRole.name === 'Admin' || userRole.name === 'Manager' || userRole.name === 'Accountant' || userRole.name === 'Reviewer') : false;
}

export default hasAccess;